'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _angular = require('angular');

var _angular2 = _interopRequireDefault(_angular);

var _angularUiRouter = require('angular-ui-router');

var _angularUiRouter2 = _interopRequireDefault(_angularUiRouter);

var _episodelist = require('./episodelist.component');

var _episodelist2 = _interopRequireDefault(_episodelist);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var episodelistModule = _angular2.default.module('episodelist', [_angularUiRouter2.default]).component('episodelist', _episodelist2.default);

exports.default = episodelistModule;


// WEBPACK FOOTER //
// ./client/app/common/reports/episodelist/episodelist.js